import * as React from "react";
import { Link, useLocation } from "react-router-dom";
import { AccountMenu } from "auth/login";
import { useAuth } from 'global/context/AuthProviderV2';
import "./header.css";

const Header = () => {
	const { isAuthenticated } = useAuth();
	const location = useLocation();
	const showTitle = location.pathname !== "/modelo" || isAuthenticated;

	return (
		<header className="header-topbar">
			<div className="header-topbar-inner">
				<div className="header-logos-wrap">
					{
						!showTitle&&
						<span className="header-logos-label">Desarrolla</span>
					}
					<Link className="header-logos-row" to="/" aria-label="Organizaciones desarrolladoras">
						<img className="header-logo-hubtec" src="/images/go/logo_HUBTEC_2025.png" alt="Hubtec" />
						<img className="header-logo-knowhub" src="/images/go/logo_knowhub.png" alt="KnowHub" />
						<img className="header-logo-apta" src="/images/go/logo_APTA.png" alt="APTA" />
					</Link>
				</div>

				{showTitle && (
					<h1 className="header-title">Calculadora Nivel de Madurez</h1>
				)}

				<nav className="header-top-links" aria-label="Navegación principal">
					<AccountMenu />
				</nav>

				{
					!isAuthenticated
					&&
					<img
						className="header-anid-logo"
						src="/landing-assets/anid-digital.png"
						alt="Agencia Nacional de Investigación y Desarrollo"
					/>
				}

			</div>
		</header>
	);
};

export default Header;
